const de = {
  articleBy: 'geschrieben von {{author}}{{department}} am {{date}}',
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Hiermit löschen Sie diesen Beitrag. Sind Sie sich wirklich sicher?'
  },
  deleteSuccessful: 'Der Beitrag wurde erfolgreich gelöscht',
  deleteFailed: 'Der Beitrag konnte nicht gelöscht werden',
  notificationSuccessful: 'Die Empfänger wurden erfolgreich informiert',
  notificationFailed: 'Die Empfänger konnten nicht informiert werden',
  openFailed: 'Beitrag konnte nicht geöffnet werden',
  sendEmail: 'Notfall Benachrichtigung',
  confirmSendEmail: 'Tatsächlich dringende Mitteilung?',
  confirmSendEmailDetail:
    'Diese Funktion *ausschließlich in wirklich dringenden Fällen* nutzen, da\ndie Empfänger ohnehin morgen per E-Mail über diesen Beitrag informiert werden.\n*E-Mail & Pushbenachrichtigung wirklich versenden?*',
  notFound: 'Beitrag konnte nicht gefunden werden',
  errorLoading: 'Beitrag konnte nicht geladen werden.',
  goToEvent: 'Zur Anmeldung'
};

export default de;
export type ArticleDetailTranslation = typeof de;
